export default "__VITE_ASSET__BMNuvCOg__"